module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousPoView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mobile-width",
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Request For Quotation")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "location"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.locationMasterList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Location",
      "isDisabled": _vm.stockInDetails.RQ_ID != ''
    },
    model: {
      value: (_vm.stockInDetails.location),
      callback: function($$v) {
        _vm.$set(_vm.stockInDetails, "location", $$v)
      },
      expression: "stockInDetails.location"
    }
  })], 1), _vm._v(" "), (_vm.itemArrayShow.length > 0) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status :")]), _c('br'), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.stockInDetails.isReseAndQuoActive,
      "name": "approval",
      "value": _vm.stockInDetails.isReseAndQuoActive == 1 ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activatestockInDetails()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.stockInDetails.isReseAndQuoActive == 1 ?
        'success' :
        'danger'
    }
  }, [_vm._v(_vm._s(_vm.stockInDetails.isReseAndQuoActive == 1 ?
    "Active" :
    "In-Active"))])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1), _vm._v(" "), (_vm.stockInDetails.RQ_ID != '') ? _c('b-row', [(_vm.itemModal.poItemId == '') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemMasterAll"
    }
  }, [_vm._v("Item Code/Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.itemMasterList,
      "option-value": "itemId",
      "option-text": "itemNameCode",
      "placeholder": "Select Item Code"
    },
    model: {
      value: (_vm.itemMasterAll),
      callback: function($$v) {
        _vm.itemMasterAll = $$v
      },
      expression: "itemMasterAll"
    }
  }), _vm._v(" "), (!_vm.itemModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemModelErrorList.itemName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openItemModal()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemMasterAll"
    }
  }, [_vm._v("Item Code/Name ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "specificPoDetail",
      "name": "specificPoDetail",
      "disabled": ""
    },
    model: {
      value: (_vm.itemModal.dummyItemName),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "dummyItemName", $$v)
      },
      expression: "itemModal.dummyItemName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Quantity "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemQuantity",
      "name": "itemQuantity",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.itemModal.itemQuantity),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "itemQuantity", $$v)
      },
      expression: "itemModal.itemQuantity"
    }
  }), _vm._v(" "), (!_vm.itemModal.itemQuantity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemModelErrorList.itemQuantity))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.itemModal.remarks),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "remarks", $$v)
      },
      expression: "itemModal.remarks"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    staticStyle: {
      "margin-top": "28px",
      "text-align": "center"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Add Items")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "beige"
    }
  }, [(_vm.itemArrayShow.length > 0) ? _c('hr', {
    staticClass: "hr-s"
  }) : _vm._e(), _vm._v(" "), (_vm.itemArrayShow.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Itemized Stock Details")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    attrs: {
      "id": "poTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Remarks")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemArrayShow), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemQuantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewModalPage(item.poItemId)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5"
  }, [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addRefuelStation
    }
  }, [_vm._v(_vm._s(_vm.editVar.Inputval))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Item-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Item Name"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemNameValue",
      "name": "itemNameValue"
    },
    model: {
      value: (_vm.itemMaster.itemNameValue),
      callback: function($$v) {
        _vm.$set(_vm.itemMaster, "itemNameValue", $$v)
      },
      expression: "itemMaster.itemNameValue"
    }
  }), _vm._v(" "), (!_vm.itemMaster.itemNameValue) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemMasterErrorList.itemNameValue))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Item Code "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemCodeValue",
      "name": "itemCodeValue"
    },
    model: {
      value: (_vm.itemMaster.itemCodeValue),
      callback: function($$v) {
        _vm.$set(_vm.itemMaster, "itemCodeValue", $$v)
      },
      expression: "itemMaster.itemCodeValue"
    }
  }), _vm._v(" "), (!_vm.itemMaster.itemCodeValue) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemMasterErrorList.itemCodeValue))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "37px"
    },
    attrs: {
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addItemMaster
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "37px"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideItemType
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop2",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eae5650","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/ResOfQuo/addResOfQuo.vue
// module id = 2617
// module chunks = 0